// extracted by mini-css-extract-plugin
export default {"messageheader":"MessageTitle_messageheader__n+3aG","image":"MessageTitle_image__Fbt9E","text":"MessageTitle_text__tQsZF"};